import axios from "axios";

export default function DeplacementService() {
  const baseUrl = `${process.env.REACT_APP_PHP_APP_URL}`;

  const addDeplacement = (data: {
    MagasinName: string;
    MagasinIntermediaire: string;
    IdCommande: string;
    Client: string;
    Adresse: string;
    Commision: number;
  }) => {
    return axios.post(`${baseUrl}/delplacement/add`, data);
  };

  const getAllDeplacement = () => {
    return axios.get(`${baseUrl}/delplacement`);
  };

  const getDeplacementByMagasin = (magasinName: string) => {
    return axios.get(`${baseUrl}/delplacement/${encodeURIComponent(magasinName)}`);
  };

  const deleteDeplacement = (id: number) => {
    return axios.get(`${baseUrl}/delplacement/delete/${id}`);
  };

  const confirmeDeplacement = (id: number) => {
    return axios.post(`${baseUrl}/delplacement/confirm/${id}`);
  };

  return {
    addDeplacement,
    getAllDeplacement,
    getDeplacementByMagasin,
    deleteDeplacement,
    confirmeDeplacement,
  };
}
